module.exports = __webpack_public_path__ + "static/img/eec-group4.a52b3572.png";